import { ErrorMessage, Field, Form, Formik } from 'formik';
import { Col, Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { clearError, forgotPassword } from '../store/Slices/AuthSlice';
import '../styles/Auth.css';
import { forgotSchema } from '../utils/Schema';
import { emailIcon } from '../utils/svgs';
import { errorNotify, successNotify } from '../utils/toast';
import { useEffect } from 'react';

const ForgotPassword = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading, error } = useSelector((state) => state.auth);

    useEffect(() => {
        return () => {
            dispatch(clearError())
        }
    }, [])

    const handleForgotPassword = async (values, { setSubmitting }) => {
        try {
            const resultAction = await dispatch(forgotPassword(values.email));

            if (forgotPassword.fulfilled.match(resultAction)) {
                successNotify('Password reset link has been sent to your email');
                navigate('/');
            }
        } catch (error) {
            errorNotify(error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className='main_auth_screen'>
            <Container fluid>
                <Row>
                    <Col md={7} className='auth_left'>
                        <div>
                            <h2>Maintenance</h2>
                            <h6>Maintenance Module Forgot Password</h6>
                        </div>
                    </Col>
                    <Col md={5} className='auth_col'>
                        <div className='auth_form'>
                            <div>
                                <h1>Forgot Password!</h1>
                                <p>Enter email for password reset</p>

                                <div className='auth_inputs'>
                                    <Formik
                                        initialValues={{
                                            email: '',
                                        }}
                                        validationSchema={forgotSchema}
                                        onSubmit={handleForgotPassword}
                                    >
                                        {({ isSubmitting }) => (
                                            <Form>
                                                <div className='mb-3'>
                                                    <div className="form-group">
                                                        {emailIcon}
                                                        <Field
                                                            type='email'
                                                            name='email'
                                                            placeholder='Enter your Email Address'
                                                            className="form-control"
                                                        />
                                                    </div>
                                                    <ErrorMessage name="email" component="div" className="error-message" />
                                                </div>

                                                {error && (
                                                    <div className="error-message" style={{ color: 'red', marginBottom: '10px' }}>
                                                        {error}
                                                    </div>
                                                )}

                                                <div className='forgot_password' onClick={() => navigate('/')}>Back to Login</div>

                                                <button
                                                    type='submit'
                                                    disabled={isSubmitting || loading}
                                                >
                                                    {loading || isSubmitting ? 'Sending...' : 'Sent Reset Link'}
                                                </button>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default ForgotPassword